import React from 'react';
import { motion } from 'framer-motion';
import SEO from '../components/SEO.jsx';
// Bioresonance International Congress & Professional Networking
import img1 from '../components/assets/Bioresonance networking/1.webp';
import img2 from '../components/assets/Bioresonance networking/2.webp';
import img3 from '../components/assets/Bioresonance networking/3.webp';
import img4 from '../components/assets/Bioresonance networking/4.webp';
import img5 from '../components/assets/Bioresonance networking/5.webp';
import img6 from '../components/assets/Bioresonance networking/6.webp';
import img7 from '../components/assets/Bioresonance networking/7.webp';
import img8 from '../components/assets/Bioresonance networking/8.webp';
import img9 from '../components/assets/Bioresonance networking/9.webp';
import img10 from '../components/assets/Bioresonance networking/10.webp';
import img11 from '../components/assets/Bioresonance networking/11.webp';
import img12 from '../components/assets/Bioresonance networking/12.webp';
import img50 from '../components/assets/ProfessionalsCollaborations/50.webp';
import img51 from '../components/assets/ProfessionalsCollaborations/51.webp';
import img52 from '../components/assets/ProfessionalsCollaborations/52.webp';
import img53 from '../components/assets/ProfessionalsCollaborations/53.webp';
import img54 from '../components/assets/ProfessionalsCollaborations/54.webp';
import img55 from '../components/assets/ProfessionalsCollaborations/55.webp';
import img56 from '../components/assets/ProfessionalsCollaborations/56.webp';
import img57 from '../components/assets/ProfessionalsCollaborations/57.webp';
import img58 from '../components/assets/ProfessionalsCollaborations/58.webp';
import img59 from '../components/assets/ProfessionalsCollaborations/59.webp';
import img60 from '../components/assets/ProfessionalsCollaborations/60.webp';
import img61 from '../components/assets/ProfessionalsCollaborations/61.webp';
import img62 from '../components/assets/ProfessionalsCollaborations/62.webp';
import img63 from '../components/assets/ProfessionalsCollaborations/63.webp';
import img64 from '../components/assets/ProfessionalsCollaborations/64.webp';
import img65 from '../components/assets/ProfessionalsCollaborations/65.webp';
import img66 from '../components/assets/ProfessionalsCollaborations/66.webp';

const congressPhotos = [
  img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12,
];

const professionalsPhotos = [
  { src: img50, description: 'Dr. med. Sabine Rauch — internationally recognized physician and BICOM® bioresonance lecturer. Olle Svensson — globally respected BICOM® bioresonance trainer and co-author.' },
  { src: img51, description: 'Global BICOM® experts and authors of The Handbook for BICOM® Bioresonance Therapy and The Energetic Anatomy of Life — Dr. med. Sabine Rauch and Olle Svensson.' },
  { src: img52, description: 'Dr. med. Sabine Rauch — internationally recognized physician and BICOM® bioresonance lecturer.' },
  { src: img53, description: 'Global BICOM® experts and authors of The Handbook for BICOM® Bioresonance Therapy and The Energetic Anatomy of Life — Dr. med. Sabine Rauch and Olle Svensson.' },
  { src: img54, description: 'Dr. med. Sabine Rauch — internationally recognized physician and BICOM® bioresonance lecturer.' },
  { src: img55, description: 'Professional collaboration at the International Congress on the Bioresonance Method.' },
  { src: img56, description: 'Dr. med. Antonia Rome — expert in integrative medicine and BICOM® bioresonance.' },
  { src: img57, description: 'Dr. med. Antonia Rome — expert in integrative medicine and BICOM® bioresonance.' },
  { src: img58, description: 'Dr. med. Ljudmila Vukosavljević — international BICOM® bioresonance trainer and integrative medicine physician.' },
  { src: img59, description: 'Dr. med. Ljudmila Vukosavljević — international BICOM® bioresonance trainer and integrative medicine physician.' },
  { src: img60, description: 'Dr. Cassandra Mougiakou — international BICOM® bioresonance trainer and integrative medicine physician.' },
  { src: img61, description: 'Dr. med. Jürgen Hennecke — pioneer of BICOM® bioresonance and international lecturer.' },
  { src: img62, description: 'Jenny Blondel — naturopath and international BICOM® bioresonance trainer.' },
  { src: img63, description: 'Kevin Zhang — international executive associated with REGUMED®.' },
  { src: img64, description: 'Dr. med. Reinald Schrüffer — leading international expert in BICOM® bioresonance and REGUMED® lecturer.' },
  { src: img65, description: 'Meeting with Dr. Inna Trakhtenberg and Polish colleagues at the International Congress on the Bioresonance Method.' },
  { src: img66, description: 'Dr. Inna Trakhtenberg — international BICOM® bioresonance trainer and integrative medicine physician.' },
];

const GalleryItem = ({ src, alt, index }) => (
  <motion.div
    initial={{ opacity: 0, y: 16 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.4, delay: index * 0.04 }}
    className="group relative aspect-square overflow-hidden rounded-xl border border-grey/20 bg-white shadow-md hover:shadow-xl transition-all duration-300"
  >
    <img
      src={src}
      alt={alt}
      loading="lazy"
      className="absolute inset-0 h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" aria-hidden />
    <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-gold/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" aria-hidden />
  </motion.div>
);

const GalleryItemWithCaption = ({ src, alt, description, index }) => (
  <motion.div
    initial={{ opacity: 0, y: 16 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.4, delay: index * 0.04 }}
    className="group flex flex-col"
  >
    <div className="relative aspect-square overflow-hidden rounded-xl border border-grey/20 bg-white shadow-md hover:shadow-xl transition-all duration-300">
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" aria-hidden />
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-gold/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" aria-hidden />
    </div>
    <p className="mt-3 text-sm text-dark-grey leading-snug px-1" style={{ fontFamily: 'Open Sans, sans-serif' }}>
      {description}
    </p>
  </motion.div>
);

const Gallery = () => {
  return (
    <div className="pt-20 min-h-screen bg-gradient-to-br from-white via-yellow/10 to-gold/5">
      <SEO
        title="Gallery"
        description="Photo gallery – Bioresonance International Congress, professional collaborations and experts. Bioresonance Leicester at 108 New Walk."
        path="/gallery"
      />
      {/* Hero */}
      <section className="relative py-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-gold/10 via-transparent to-blue/10" aria-hidden />
        <div className="container mx-auto px-4 relative z-10">
          <div className="text-center max-w-4xl mx-auto">
            <h1 className="text-5xl md:text-6xl font-bold text-dark-grey mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
              Gallery
            </h1>
            <p className="text-xl text-dark-grey leading-relaxed max-w-3xl mx-auto">
              Moments from our events, congress participation, and professional collaborations.
            </p>
          </div>
        </div>
      </section>

      {/* Section: Professionals & Collaborations */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-dark-grey mb-10 text-center" style={{ fontFamily: 'Playfair Display, serif' }}>
            Professionals & Collaborations
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8 max-w-6xl mx-auto">
            {professionalsPhotos.map(({ src, description }, index) => (
              <GalleryItemWithCaption
                key={`pro-${index}`}
                src={src}
                alt={description}
                description={description}
                index={index}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Section: Bioresonance International Congress & Professional Networking */}
      <section className="py-16 bg-white/80">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-dark-grey mb-10 text-center" style={{ fontFamily: 'Playfair Display, serif' }}>
            Bioresonance International Congress & Professional Networking
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6 max-w-6xl mx-auto">
            {congressPhotos.map((src, index) => (
              <GalleryItem
                key={src}
                src={src}
                alt={`Bioresonance congress and networking ${index + 1}`}
                index={index}
              />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Gallery;
